import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-multimedia-grid-layout-item',
  imports: [],
  templateUrl: './multimedia-grid-layout-item.component.html',
  styleUrl: './multimedia-grid-layout-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaGridLayoutItemComponent {}
